import _                              from 'underscore';
import React, { useEffect, useState } from 'react';
import { Checkbox, List }             from 'semantic-ui-react';

import { runIfFunction } from '../../../../../../../util';

interface CompareProjectToggleToolOptionsProps<T = never> {
	initialValue?: boolean,
	header?: string,
	label?: string,
	onChange: ( data: CompareProjectToggleToolOptionsData ) => void,
	
}

interface CompareProjectToggleToolOptionsData<T = never> {
	isActive: boolean
}

const compareProjectToggleToolDefaultOptions = true;

function CompareProjectToggleToolOptions<T>(
	{
		header = null,
		label = 'Toggle X',
		initialValue = compareProjectToggleToolDefaultOptions,
		onChange = null,
	}: CompareProjectToggleToolOptionsProps<T> ){
	
	const [ active, setActive ] = useState<boolean>( initialValue );
	
	useEffect( () => {
		
		runIfFunction( onChange, active );
		
	}, [ active ] );
	
	const handleOnChanged = ( e, data ) => {
		
		const checked = data.checked;
		
		setActive( checked )
		
	}
	
	return (
		<>
			{ _.isString( header ) && <h5>{ header }</h5> }
			
			<List relaxed divided>
				
				<List.Item>
					<Checkbox
						label={ label }
						value={ label }
						defaultChecked={ active }
						onChange={ handleOnChanged }/>
				
				</List.Item>
			</List>
		</>
	);
}

export {
	CompareProjectToggleToolOptions,
	compareProjectToggleToolDefaultOptions
};
